const ddadosAtividade = {
  Titulo: "Atividades",
  Campos: {
    //DDados Atividades
    SuggestionAtividade: {
      Tipo: "multipleselect",
      Label: "Atividades",
      Tooltip: "Código - Atividade",
      Placeholder: "Código - Atividade",
    },
  },
};

export { ddadosAtividade };
